export const enum BOTONES {
    INFO = 'info',
    BOTON = 'boton'
}